export default function getDistanceBetween(pointA, pointB) {
  return haversineDistance(
    [pointA.address.longitude, pointA.address.latitude],
    [pointB.address.longitude, pointB.address.latitude],
    true
  )
}

function haversineDistance(coords1, coords2, isMiles) {
  function toRad(x) {
    return (x * Math.PI) / 180
  }

  const lon1 = coords1[0]
  const lat1 = coords1[1]

  const lon2 = coords2[0]
  const lat2 = coords2[1]

  const R = 6371 // km

  const x1 = lat2 - lat1
  const dLat = toRad(x1)
  const x2 = lon2 - lon1
  const dLon = toRad(x2)
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  let d = R * c

  if (isMiles) d /= 1.60934

  return d
}
